// ══════════════════════════════════════════════════════════════════════════════
// FEED ÉQUIPE PRO - Style Workplace by Meta
// Posts, Photos, Vidéos, Sondages, Événements, Réactions, Commentaires, Mentions
// ══════════════════════════════════════════════════════════════════════════════

import React, { useState, useEffect } from 'react';
import { Users, Loader2 } from 'lucide-react';
import { WorkplaceFeed } from '../../../components/feed';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function FeedProPage() {
  const [teams, setTeams] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);

  const token = localStorage.getItem('token');
  const headers = { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' };

  useEffect(() => {
    fetchTeams();
    fetchCurrentUser();
  }, []);

  const fetchCurrentUser = async () => {
    try {
      const res = await fetch(`${API_URL}/api/auth/me`, { headers });
      if (res.ok) {
        const data = await res.json();
        setCurrentUser(data);
      }
    } catch (error) {
      console.error('Erreur user:', error);
    }
  };

  const fetchTeams = async () => {
    try {
      const res = await fetch(`${API_URL}/api/pro/teams`, { headers });
      if (res.ok) {
        const data = await res.json();
        setTeams(data);
        if (data.length > 0) {
          setSelectedTeam(data[0]);
        }
      }
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <Loader2 className="w-8 h-8 animate-spin text-[#E8650A]" />
      </div>
    );
  }

  if (teams.length === 0) {
    return (
      <div className="p-6">
        <div className="bg-white rounded-xl border border-gray-200 p-8 text-center">
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-[#1E3A5F]/10 flex items-center justify-center">
            <Users className="w-8 h-8 text-[#1E3A5F]" />
          </div>
          <h3 className="text-lg font-semibold text-[#1E3A5F] mb-2">Aucune équipe</h3>
          <p className="text-gray-500">Crée d'abord une équipe pour partager des publications avec tes collaborateurs.</p>
          <a 
            href="/cockpit-pro/collaboration/equipe" 
            className="inline-block mt-4 px-4 py-2 bg-[#E8650A] text-white rounded-lg hover:bg-[#d55a09] transition-colors"
          >
            Créer une équipe
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="p-4 md:p-6 max-w-2xl mx-auto space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-[#1E3A5F]">Feed équipe</h1>
          <p className="text-gray-500 text-sm">
            Partage des infos, sondages et événements avec ton équipe
          </p>
        </div>
        {teams.length > 1 && (
          <select
            value={selectedTeam?.id || ''}
            onChange={(e) => {
              const team = teams.find(t => t.id === e.target.value);
              setSelectedTeam(team);
            }}
            className="px-3 py-2 border border-gray-300 rounded-lg bg-white text-sm"
          >
            {teams.map(team => (
              <option key={team.id} value={team.id}>{team.name}</option>
            ))}
          </select>
        )}
      </div>

      {/* Feed Workplace */}
      {selectedTeam && (
        <WorkplaceFeed
          contextType="team"
          contextId={selectedTeam.id}
          token={token}
          currentUser={currentUser}
          members={selectedTeam.members || []}
          accentColor="#E8650A"
          emptyStateMessage="Aucune publication dans cette équipe"
        />
      )}
    </div>
  );
}
